import React from "react";
import { Link as RouterLink } from "react-router-dom";

const section = {
  background: "#fff",
  borderRadius: 16,
  padding: "22px 22px 8px",
  marginBottom: 14,
  border: "1px solid rgba(15,23,42,0.06)",
};

const Privacy = () => (
  <main style={{ minHeight: "100vh", background: "linear-gradient(180deg, #f7f9ff 0%, #edf2ff 100%)", padding: "32px 16px 72px", fontFamily: "Inter, sans-serif", color: "#0f172a" }}>
    <article style={{ maxWidth: 760, margin: "0 auto" }}>
      <p style={{ marginBottom: 8 }}><RouterLink to="/login" style={{ color: "#2563eb", fontWeight: 700 }}>Volver al inicio</RouterLink></p>
      <h1 style={{ fontSize: 36, letterSpacing: -0.6, marginBottom: 8 }}>Política de privacidad</h1>
      <p style={{ color: "#475569", lineHeight: 1.6, marginTop: 0 }}>
        Qué datos personales tratamos en la plataforma, para qué, con quién los compartimos, cuánto tiempo los guardamos y cómo puedes ejercer tus derechos.
        Esta política se aplica al panel de empresas operado por StreamDIGI. Cumplimos la Ley N.º 29733 de Protección de Datos Personales del Perú y su reglamento.
      </p>

      <section style={section}>
        <h2>1. Responsable</h2>
        <p>StreamDIGI es responsable de los datos de las empresas, sus administradores y colaboradores que usan este panel.</p>
        <p>Para ver, corregir o eliminar tus datos, escríbenos desde el correo con el que te registraste e indica tu nombre, ese correo y qué necesitas.</p>
      </section>

      <section style={section}>
        <h2>2. Empresas y sus clientes</h2>
        <ul>
          <li>Administradores, colaboradores y visitantes de este sitio: StreamDIGI es responsable y esta política se les aplica.</li>
          <li>Clientes de cada empresa: el responsable es la empresa dueña de esa cuenta. StreamDIGI guarda y procesa esos datos por encargo suyo, para que su operación funcione, y no los usa para fines propios. Cada tienda publica su propio tratamiento de datos.</li>
        </ul>
        <p>Si eres cliente de una tienda y quieres ver, corregir o borrar tus datos, pídeselo a esa tienda. Si no te responde, escríbenos y lo gestionamos con ella.</p>
      </section>

      <section style={section}>
        <h2>3. Qué datos tratamos</h2>
        <p>De las empresas y sus colaboradores:</p>
        <ul>
          <li>Nombre, correo, contraseña (solo guardamos su huella cifrada) y WhatsApp.</li>
          <li>Datos del negocio: nombre, logo, horarios, departamentos y conexiones de WhatsApp o Telegram que la empresa activa.</li>
          <li>Chats, contactos, etiquetas, campañas, estados y archivos que el equipo carga para atender.</li>
          <li>Si la empresa usa la tienda: catálogo, precios, pedidos, saldo y las credenciales de las cuentas que registra, guardadas para entregar el servicio.</li>
          <li>Si conecta un correo para leer códigos de plataformas, guardamos el acceso de esa bandeja para encontrar esos códigos. No lo usamos para otra cosa.</li>
          <li>Seguridad: historial de acceso necesario para mantener la sesión y el registro de acciones del panel.</li>
        </ul>
        <p>De los clientes de cada empresa, por encargo de esa empresa: nombre, WhatsApp, compras, servicios, saldo y los mensajes que intercambian con la tienda.</p>
        <p>De quien visita este sitio: los datos técnicos que el navegador envía para mantener la sesión.</p>
      </section>

      <section style={section}>
        <h2>4. Para qué los usamos</h2>
        <ul>
          <li>Crear la cuenta y prestar el servicio contratado.</li>
          <li>Confirmar el correo y el WhatsApp, y evitar registros repetidos o automatizados.</li>
          <li>Cobrar el plan y llevar la contabilidad de la suscripción.</li>
          <li>Enviar avisos del servicio: acceso, vencimientos y seguridad.</li>
          <li>Atender los chats y ejecutar las campañas y automatizaciones que la empresa configura.</li>
        </ul>
        <p>No vendemos datos personales ni los usamos para decidir nada de forma automática sobre ti.</p>
      </section>

      <section style={section}>
        <h2>5. Con quién los compartimos</h2>
        <p>Solo con proveedores que necesitamos para funcionar, que tratan los datos por encargo y bajo obligación de confidencialidad:</p>
        <ul>
          <li>El proveedor que aloja la plataforma y su base de datos.</li>
          <li>El servicio de correo que envía la confirmación de cuenta y la recuperación de contraseña.</li>
          <li>WhatsApp y Telegram, cuando la empresa conecta esos canales para atender a sus contactos.</li>
          <li>El servicio de imágenes, cuando una empresa sube un logo o un comprobante.</li>
        </ul>
        <p>También podemos entregar datos a una autoridad cuando la ley nos obligue.</p>
      </section>

      <section style={section}>
        <h2>6. Datos fuera de tu país</h2>
        <p>Algunos de estos proveedores pueden estar fuera del Perú. Solo transferimos datos para las finalidades de esta política y con proveedores que ofrecen garantías de seguridad adecuadas.</p>
      </section>

      <section id="cookies" style={section}>
        <h2>7. Cookies</h2>
        <ul>
          <li>Necesarias: mantienen la sesión iniciada y el funcionamiento del sitio. No piden permiso, porque sin ellas el panel no funciona.</li>
          <li>Preferencias: recuerdan si aceptaste o rechazaste este aviso.</li>
        </ul>
        <p>No usamos cookies de análisis ni de publicidad. Rechazar el aviso no corta las cookies necesarias.</p>
      </section>

      <section style={section}>
        <h2>8. Cuánto tiempo los guardamos</h2>
        <ul>
          <li>Mientras la cuenta de la empresa esté activa.</li>
          <li>Un registro que no confirma el correo no puede iniciar sesión. Puedes pedir que lo eliminemos.</li>
          <li>Los datos de pagos, el tiempo que exijan las normas contables y tributarias.</li>
          <li>Las copias de seguridad se renuevan de forma periódica.</li>
        </ul>
      </section>

      <section style={section}>
        <h2>9. Cómo los protegemos</h2>
        <ul>
          <li>Las contraseñas se guardan solo como huella cifrada.</li>
          <li>La conexión del sitio va cifrada (HTTPS).</li>
          <li>Cada empresa accede a sus propios datos.</li>
        </ul>
        <p>Si ocurre un incidente que ponga en riesgo tus datos, te avisaremos y lo comunicaremos a la autoridad cuando corresponda.</p>
      </section>

      <section style={section}>
        <h2>10. Tus derechos</h2>
        <p>En cualquier momento, y gratis, puedes pedirnos acceso, rectificación, cancelación u oposición, y retirar una autorización que nos hayas dado.</p>
        <p>Te responderemos dentro de los plazos que fija la ley. Si no quedas conforme, puedes reclamar ante la Autoridad Nacional de Protección de Datos Personales del Ministerio de Justicia y Derechos Humanos del Perú, o ante la autoridad de tu país.</p>
        <p style={{ color: "#64748b" }}>Desarrollado por StreamDIGI.</p>
      </section>
    </article>
  </main>
);

export default Privacy;
